import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { uiLocales, UI_NAMESPACES } from '@wehunt/ui'
import commonSv from './locales/sv.json'
import commonEn from './locales/en.json'
// Data-table translations are cloned locally (clone-and-own) so clubhouse owns
// its `table` namespace and does not reach across the domain boundary into
// chronicle (RULE-002). Chronicle keeps its own copy for its statistics views.
import tableSv from './locales/table.sv.json'
import tableEn from './locales/table.en.json'

const isDev = import.meta.env?.DEV === true

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'sv',
    supportedLngs: ['sv', 'en'],
    // The shared @wehunt/ui components (AppShell, Sidebar, ThemeToggle, …)
    // resolve their strings from these namespaces; without them their labels
    // render as raw keys (e.g. the theme toggle showed "theme.dark"). Resources
    // are registered via addResourceBundle after init (below).
    ns: Array.from(new Set(['common', 'table', ...UI_NAMESPACES])),
    defaultNS: 'common',
    resources: {
      sv: { common: commonSv, table: tableSv },
      en: { common: commonEn, table: tableEn },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    saveMissing: isDev,
    missingKeyHandler: isDev
      ? (lngs, ns, key) => {
          // eslint-disable-next-line no-console -- dev-only signal for missing keys
          console.error(`[i18n] missing key ${ns}:${key} (langs: ${lngs.join(',')})`)
          throw new Error(`Missing i18n key: ${ns}:${key}`)
        }
      : undefined,
  })

// Register the @wehunt/ui shared-component locale bundles (nav, actions, …).
// deepMerge=true folds the lib's `common` into the domain `common`;
// overwrite=false so domain keys win on any collision (mirrors wehunt-web).
for (const [lng, bundles] of Object.entries(uiLocales)) {
  for (const [ns, resources] of Object.entries(bundles)) {
    i18n.addResourceBundle(lng, ns, resources, true, false)
  }
}

export { i18n }
